module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-scroller/index.js
// module id = 1898
// module chunks = 0